import * as contentful from 'contentful'

export default contentful.createClient({
  space: process.env.CONTENTFUL_SPACE_ID || 'qg8tuesv5cq2',
  environment: 'master', // || 'development',
  accessToken:
    process.env.CONTENTFUL_ACCESS_TOKEN ||
    '05720fee4f0e873590ef085a3b7ec7ff1fa28c1d8e2272823772a99d8b1a6fdc',
  host: process.env.CONTENTFUL_HOST || 'preview.contentful.com',
})
